<div [ngClass]="cssService.footerProductOrder">

  <!-- Content -->
  <div *ngIf="!showSearchInput" class="flex flex-row justify-between px-4 w-full h-full">

    <!-- Bouton Rechercher -->
    <button (click)="openSearchInput()" class="flex items-center gap-2 text-gray-700 hover:text-black font-medium">
      <i class="material-icons text-indigo-500">search</i>
      <span>{{'dashboardComponent.search'|translate}}</span>
    </button>

    <!-- Bouton Mon Panier -->
    <button (click)="openBasket()" class="relative flex items-center gap-3 text-gray-800 font-semibold px-6 py-2">
      <i class="material-icons text-green-600">shopping_cart</i>
      <div class="text-left min-w-[100px]">
        <div class="text-sm leading-tight">{{'mybasket'|translate}}</div>
        <div class="text-sm text-gray-500">{{ totalPricePan | priceFilter }}</div>
      </div>
      <!-- Badge nombre d'articles -->
      <span class="absolute -top-1 -right-1 bg-green-600 text-white text-xs px-1.5 rounded-full">
        {{ basket$.length }}
      </span>
    </button>

    <!-- Button search product
    <button *ngIf="tools.checkCurrentPage('Product')" fxHide.gt-md mat-icon-button (click)="openSearchInput()">
      <mat-icon>search</mat-icon>
    </button> -->

    <!-- Button Back page endorder
    <button *ngIf="tools.checkCurrentPage('Endorder')" class="primary-ico" mat-stroked-button (click)="goProduct()">
      <mat-icon> keyboard_arrow_left </mat-icon>
      <mat-icon> shopping_cart </mat-icon>
    </button> -->

    <!-- Fillers (Remplisseurs)
    <div *ngIf="tools.checkCurrentPage('Product')" fxHide.gt-md fxHide.xs fxFlex></div>
    <div *ngIf="!tools.checkCurrentPage('Product')" fxHide.xs fxFlex></div>

    <button *ngIf="basket$.length > 0 && tools.checkCurrentPage('Pointofsale')" class="primary-ico" mat-stroked-button
      (click)="goNextPage()">
      <mat-icon> shopping_cart </mat-icon>
      <mat-icon> keyboard_arrow_right </mat-icon>
    </button>

    <button mat-raised-button class="great rounded-button min200" (click)="openBasket()"
      *ngIf="tools.checkCurrentPage('Product') && toggleBasket">
      <span>{{'mybasket'|translate}} ({{ basket$.length }}):
        {{ totalPricePan | priceFilter }}</span>
    </button>

    <button mat-button *ngIf="tools.checkCurrentPage('Product') && !toggleBasket" (click)="openBasket()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>-->

    <!-- Button finish order page endorder
    <button *ngIf="tools.checkCurrentPage('Endorder') && user$" class="great-ico" mat-stroked-button
      (click)="goNextPage()">
      <mat-icon> attach_money </mat-icon>
    </button>-->
  </div>

  <!-- Input search -->
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlex *ngIf="showSearchInput" class="layout-padd"
    [ngStyle.gt-sm]="{ 'margin-right': '400px' }">
    <mat-icon class="clicked" (click)="setShowSearchInput(false); setFindedProducts(null)">close</mat-icon>

    <div fxLayout="column" *ngIf="showSearchInput" fxFlex>
      <form [formGroup]="searchProductForm" fxLayoutAlign="space-between center" fxLayoutGap="10px" fxFlex>
        <input type="text" pInputText placeholder="{{'searchProdPlaceholder'|translate}}" formControlName="searchProductInput"
          #searchInput fxFlex />
      </form>
      <mat-progress-bar mode="buffer" *ngIf="searchProductLoader"></mat-progress-bar>
    </div>
  </div>
</div>
